@if(isPageRestrictionLoaded){
<div class="ppl-container-body">
  <div class="ppl-container no-margin">
    <div class="ppl-content-container no-left-padding" style="box-sizing: border-box;">
      <div class="line1">

        @if (showBackButton) {
        <div class="action">
          <ppl-button [label]="backLabel" (click)="navigateToLeads()" icon="fa fa-chevron-left"
            [customClass]="'primary-button semi-rounded'" [iconPosition]="'left'"></ppl-button>
        </div>
        }

        <div class="page-title" aria-live="polite">
          <img class="profile-icon" src="../../assets/images/account_circle_24dp_E8EAED_FILL1_wght400_GRAD0_opsz24.svg"
            alt="User profile image">
          <span>Details for {{ filledInfo?.fname }}</span>
        </div>

        <div class="actGRP">
          <ppl-button label="Communication Logs" icon="fa fa-comments-o" [customClass]="'ghost-button'"
            [iconPosition]="'left'" (click)="communicationLogs()"
            *authorize="[pageId, tabId, 'communication_logs', 'button']"></ppl-button>

          <ppl-button label="History" icon="fa fa-history" [customClass]="'ghost-button'" [iconPosition]="'left'"
            *authorize="[pageId, tabId, 'change_history', 'button']" (click)="getLeadHistory()"></ppl-button>

          <ppl-button label="Comments" icon="fa fa-comment" [customClass]="'ghost-button'" [iconPosition]="'left'"
            (click)="comments()" *authorize="[pageId, tabId, 'comments', 'button']"></ppl-button>

          <ppl-actions *authorize="[pageId, tabId, 'actions', 'button']"
            [listButton]="listButton"
            [selectedCheckBoxValue]="applicationData"
            [sourcePage]="entry"
            (leadUpdated)="getUpdatedLeadData($event)"
            [from]="'details'"
            [detailContactInfo]="{ emails: emailId, phones: mobileNumber }"></ppl-actions>

        </div>
      </div>

      <div style="width: 100%; box-sizing: border-box;">

        <!-- <ppl-tabbed-panel [horizontalMenuItemstoDisplay]="horizontalMenuItemstoDisplay">
    
  </ppl-tabbed-panel> -->



        <div class="ppl-tabs">
          <nz-tabset
            [nzAnimated]="false"
            [nzTabBarGutter]="8"
            [nzTabBarStyle]="{ 'margin-bottom': '12px' }"
            [nzType]="'line'"
            [nzSelectedIndex]="selectedTabIndex"
            (nzSelectedIndexChange)="onTabIndexChange($event)">
            <nz-tab *ngFor="let menuItem of horizontalMenuItemstoDisplay"
              [nzTitle]="menuItem.menu_label">
            </nz-tab>
          </nz-tabset>

          <!-- Tab Content -->
          <div class="tab-content" role="tabpanel" tabindex="-1"
          [attr.id]="'tabpanel-' + selectedMenuItem"
          [attr.aria-labelledby]="'tab-' + selectedMenuItem"
          (keydown)="onPanelKeydown($event)"
          #tabPanel>
            <router-outlet></router-outlet>
          </div>
        </div>

      </div>

      <ppl-side-drawer [width]="'1100px'" *authorize="[pageId, tabId, 'communication_logs', 'button']"
        [(isSideDrawerVisible)]="isCommunicationLogs" [title]="'Communication Logs'"
        (close)="isCommunicationLogs = false">
        <ppl-communication-logs [sourcePage]="entry" [leadId]="id" [program]="program.program_code"
          [isCommunicationLogs]="isCommunicationLogs"></ppl-communication-logs>
      </ppl-side-drawer>


      <ppl-side-drawer *authorize="[pageId, tabId, 'change_history', 'button']" [(isSideDrawerVisible)]="isAuditHistory"
        [title]="'Audit History'" (close)="isAuditHistory = false">
        <ppl-timeline [data]="auditHistory"></ppl-timeline>
      </ppl-side-drawer>

      @if(filledInfo){

      <ppl-side-drawer [width]="'800px'" *authorize="[pageId, tabId, 'comments', 'button']"
        [(isSideDrawerVisible)]="enableComments" [title]="'Comments'" (close)="enableComments = false">
        <ppl-lead-comments [sourcePage]="entry" [sectionData]="steps" [leadId]="id" [program]="program.program_code"
          (leadUpdated)="getUpdatedLeadData($event)" [clearComments]="enableComments"></ppl-lead-comments>
      </ppl-side-drawer>

      }
      <ppl-notification-sms [show]="showSMSModal" [notificationType]="notificationType"
        (onHandleCancel)="onHandleCancel($event)" [selectedCheckBoxValue]="applicationData"
        [sourcePage]="'details'"></ppl-notification-sms>
    </div>
  </div>
</div>
}